// npm packages
import React from 'react';

// utils
import { cn } from '@/utils/cn';

// components
import Icon from '../Icon';

function ExploreAllDeals({
  children,
  className = '',
  color = '#FFF',
  disabled = false,
  ...rest
}) {
  return (
    <button
      type="button"
      className={cn(
        `w-full h-[30px] lg:h-[50px] rounded-[100px] flex justify-between items-center gap-[2px] bg-pacific-queen px-16`,
        {
          'bg-disabled': disabled,
        },
        className,
      )}
      disabled={disabled}
      {...rest}
    >
      {children}
      <Icon
        type="angle-down"
        color={color}
        className="-rotate-90 size-[14px] lg:size-[26px]"
      />
    </button>
  );
}

export default ExploreAllDeals;
